<template>
  <div class="Site PageBox" style="background-color: var(--background-main)">
    <van-nav-bar
      fixed
      :border="false"
      :title="this.$t('Finance[11]')"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div v-if="infoData" class="ScrollBox">
      <div class="con-box">
        <div class="title">
          {{infoData.title}}
        </div>
        <div class="money">
          <div>
            <p>{{$t('Finance[6][1]')}}</p>
            <small>{{InitData.currency}}</small>{{Number(infoData.money)}}
          </div>
          <div>
            <p>{{$t('Finance[6][5]')}}</p>
            {{Number(infoData.number)}}
          </div>
          <div>
            <p>{{$t('Finance[12][0]')}}</p>
            <small>{{InitData.currency}}</small>{{Number(infoData.order_money)}}
          </div>
        </div>
        <div class="info">
          <div>
            <label>{{$t('Finance[12][1]')}}</label>
            <span :class="{active: infoData.state==1}">{{infoData.state_dec}}</span>
          </div>
          <div>
            <label>{{$t('Finance[12][2]')}}</label>
            <span>{{infoData.buy_time}}</span>
          </div>
          <div>
            <label>{{$t('Finance[6][3]')}}</label>
            <span>{{infoData.all_day}} {{$t('Finance[6][4]')}}</span>
          </div>
          <div v-if="infoData.daily_dividend">
            <label>{{$t('Finance[0][0]')}}</label>
            <span v-if="infoData.profit_multiple">{{Number(infoData.daily_dividend)}} x {{Number(infoData.profit_multiple)}} {{$t('Finance[0][4]')}} = {{InitData.currency}}{{$Util.KeepDecimal(Number(infoData.daily_dividend)*Number(infoData.profit_multiple),2)}}</span>
            <span v-else>{{InitData.currency}}{{Number(infoData.daily_dividend)}}</span>
          </div>
          <div v-if="infoData.equity">
            <label>{{$t('Finance[0][1]')}}</label>
            <span v-if="infoData.profit_multiple">{{Number(infoData.equity)}} x {{Number(infoData.profit_multiple)}} {{$t('Finance[0][4]')}} = {{InitData.currency}}{{$Util.KeepDecimal(Number(infoData.equity)*Number(infoData.profit_multiple),2)}}</span>
            <span v-else>{{InitData.currency}}{{Number(infoData.equity)}}</span>
          </div>
          <div v-if="infoData.options">
            <label>{{$t('Finance[0][2]')}}</label>
            <span v-if="infoData.profit_multiple">{{Number(infoData.options)}} x {{Number(infoData.profit_multiple)}} {{$t('Finance[0][4]')}} = {{InitData.currency}}{{$Util.KeepDecimal(Number(infoData.options)*Number(infoData.profit_multiple),2)}}</span>
            <span v-else>{{InitData.currency}}{{Number(infoData.options)}}</span>
          </div>
          <div v-if="infoData.subsidy">
            <label>{{$t('Finance[0][3]')}}</label>
            <span v-if="infoData.profit_multiple">{{Number(infoData.subsidy)}} x {{Number(infoData.profit_multiple)}} {{$t('Finance[0][4]')}} = {{InitData.currency}}{{$Util.KeepDecimal(Number(infoData.subsidy)*Number(infoData.profit_multiple),2)}}</span>
            <span v-else>{{InitData.currency}}{{Number(infoData.subsidy)}}</span>
          </div>
        </div>
      </div>
      <div class="con-box" style="padding: 0 8px">
        <div class="table-box">
          <table width="100%">
            <tbody>
              <tr v-for="item,index in infoData.income_model" :key="index">
                <td>
                  {{$t('Finance[4][0]')}}
                  <p>({{Number(item.profit)}}%)</p>
                </td>
                <td v-for="date,i in item.day" :key="i">
                  {{date.day}}{{$t('Finance[4][1]')}}
                  <div>{{Number(date.income)}}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="infoData.profit_multiple" class="table-mark">×{{Number(infoData.profit_multiple)}}</div>
      </div>
      <div v-if="infoData.state==1" class="block-box"></div>
      <div v-if="infoData.state==1" class="submit-btn">
        <van-button round type="danger" block style="font-size:16px" @click="transferOut('income')">{{$t('Finance[9][0]')}}</van-button>
        <van-button round type="primary" block style="font-size:16px;margin-left: 10px" @click="transferOut('all')">{{$t('Finance[9][1]')}}</van-button>
      </div>
    </div>
    <van-loading v-else size="60px" vertical style="margin-top: 50%">{{$t('dialog[6]')}}</van-loading>
  </div>
</template>

<script>
export default {
  name: 'FinanceOrder',
  components: {

  },
  props: ['orderId'],
  data() {
    return {
      infoData: '',
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.getInfoData()
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    getInfoData() {
      this.$Model.GetFinanceOrderDetail({id: this.orderId},data=>{
        this.infoData = data
      })
    },
    transferOut(type) {
      let msg = this.$t('Finance[10][0]')
      if(type=='all'){
        msg = this.$t('Finance[10][1]')
      }
      this.$Dialog.Confirm(msg,()=>{
        this.$Model.OutFinanceOrder({orderId: this.orderId, outType: type},data=>{
          if(data.code==1){
            this.getInfoData()
          }
        })
      })
    },
  }
}
</script>
<style scoped>
.con-box {
  margin: 12px;
  background-color: var(--background-theme);
  border-radius: 10px;
  padding: 20px;
  line-height: 1;
  position: relative;
}
.con-box .title{
  font-size: 18px;
}
.con-box .money{
  text-align: center;
  font-size: 24px;
  color: var(--color-important);
  display: flex;
  justify-content: space-between;
  margin: 15px 0;
  border-top: 1px solid var(--border-color-main);
  border-bottom: 1px solid var(--border-color-main);
  padding: 15px 0;
}
.con-box .money p{
  font-size: 13px;
  margin-bottom: 6px;
  color: var(--color-main);
}
.con-box .info>div{
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.con-box .info .active{
  color: var(--color-active);
}
.con-box .dec{
  text-align: center;
  border-top: 1px #eee solid;
  padding-top: 15px;
  margin-top: 15px!important;
}
.table-box{
  line-height: 1;
  font-size: 12px;
  text-align: center;
  overflow-x: auto;
  padding: 8px 0;
}
.table-box tr+tr{
  border-top: 1px #ddd solid;
}
.table-box td+td{
  border-left: 1px #ddd solid;
}
.table-box td{
  padding: 6px 3px;
}
.table-box td p{
  margin-top: 5px;
}
.table-box td div{
  margin-top: 5px;
  color: var(--color-important);
}
.table-mark {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 120px;
  color: var(--color-important);
  opacity: .6;
  pointer-events: none;
}
.submit-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px;
  display: flex;
}
.block-box{
  height: 70px;
}
</style>